export var actionKey = '@@NETWORKBAR';
export var reduxKey = '@@NETWORKBAR';
export var watchedGroupsStreamId = 'NETWORKBAR_WATCHED_GROUPS';
export var recommendedGroupsStreamId = 'NETWORKBAR_RECOMMENDED_GROUPS';
export var NETWORKBAR_FEEDBACK_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdkyYiYGzr35W_LehINmm-cFCFyijUsGsN-5W3ROazazCQ4dQ/viewform?usp=sf_link';
//# sourceMappingURL=constants.js.map